export const institutos = {
  'undefined': '',
  '0': 'Itbm',
  '1': 'Meksika',
  '2': 'Orta Amerika ve Karayipler',
  '3': 'Çin ve Büyük Çin',
  '4': 'Singapur',
  '5': 'Türkiye',
  '6': 'Philippines',
  '7': 'Ekvador',
  '8': 'izzi',
  '9': 'Romanya',
  '15': 'ispanya',
  '16': 'Itbm',
  '17': 'One Survey',
}


export const sectores = {
  "1":{
     "NOMBRE":"2.0 Havacılık",
     "SUBSECTORES":{
        "1":"2.1 Havacılık // Diğer / Geçerli değil"
     }
  },
  "2":{
     "NOMBRE":"4.0 Tarım",
     "SUBSECTORES":{
        "1":"4.1 Tarım // Diğer / Geçerli değil "
     }
  },
  "3":{
     "NOMBRE":"5.0 Biyoteknoloji ve İlaç",
     "SUBSECTORES":{
        "1":"5.1 Biyoteknoloji ve Farmasötik // Biyoteknoloji",
        "2":"5.2 Biyoteknoloji ve Farmasötik // Farmasötik",
        "3":"5.3 Biyoteknoloji ve Farmasötik // Diğer"
     }
  },
  "4":{
     "NOMBRE":"6.0 İnşaat",
     "SUBSECTORES":{
        "1":"(ESKİ) İnşaat // Taahhüt",
        "2":"(ESKİ) İnşaat // Altyapı",
        "3":"6.1 Yapı // Diğer / Geçerli değil"
     }
  },
  "5":{
     "NOMBRE":"12.0 Sağlık Hizmetleri",
     "SUBSECTORES":{
        "1":"(ESKİ) Sağlık Hizmetleri // Yatılı Bakım Hizmetleri",
        "2":"12.1 Sağlık Hizmetleri // Hastane",
        "3":"12.2 Sağlık Hizmetleri // Tıbbi Malzeme Satışı veya Dağıtımı",
        "4":"12.3 Sağlık Hizmetleri // Uzmanlık",
        "5":"(ESKİ) Yaşlandırma Hizmetleri // Evde Bakım",
        "6":"(ESKİ) Yaşlanma hizmetleri // Yaşlılar için barınma ve bakım",
        "7":"(ESKİ) Tıbbi bakım // Diğer özel hizmetler",
        "8":"12.4 Sağlık Hizmetleri // Hizmetler",
        "9":"12.5 Sağlık Hizmetleri // Diğer",
     }
  },
  "6":{
     "NOMBRE":"7.0 Eğitim ve öğretim",
     "SUBSECTORES":{
        "1":"7.1 Eğitim ve öğretim // Diğer / Geçerli değil"
     }
  },
  "7":{
     "NOMBRE":"13.0 Misafirperverlik",
     "SUBSECTORES":{
        "3":"13.1 Ağırlama // Yiyecek ve içecek servisi",
        "2":"13.2 Ağırlama // Otel / Tatil Köyü",
        "1":"13.3 Ağırlama // Yönetim",
        "4":"13.4 Ağırlama // Diğer"
     }
  },
  "8":{
     "NOMBRE":"16.0 İmalat ve üretim",
     "SUBSECTORES":{
        "28":"16.1 İmalat ve Üretim // Alternatif Enerji",
        "1":"16.2 İmalat ve Üretim // Otomotiv",
        "15":"16.3 İmalat ve Üretim // Ana Metaller ve Metal Ürünler",
        "14":"16.4 İmalat ve Üretim // İnşaat Malzemeleri",
        "24":"16.5 İmalat ve Üretim // Kimyasallar",
        "3":"16.6 İmalat ve Üretim // Kok, petrol türevleri ve nükleer yakıt",
        "8":"16.7 İmalat ve Üretim // Elektrikli, elektronik ve optik ekipmanlar",
        "6":"16.8 İmalat ve Üretim // Elektronik",
        "7":"16.9 İmalat ve Üretim // Enerji",
        "5":"16.10 İmalat ve Üretim // Enerji Dağıtımı",
        "20":"16.11 İmalat ve Üretim // Gıda Ürünleri: Süt ve kümes hayvanları ürünleri",
        "21":"16.12 İmalat ve Üretim // Gıda Ürünleri: Tütün",
        "19":"16.13 İmalat ve Üretim // Gıda Ürünleri: İçecekler",
        "18":"16.14 İmalat ve Üretim // Gıda Ürünleri: Diğerleri",
        "16":"16.15 İmalat ve İmalat // Mobilya",
        "10":"16.16 İmalat ve Üretim // Benzin / Perakende",
        "31":"16.17 İmalat ve Üretim // Sağlık",
        "17":"16.18 İmalat ve Üretim // Deri ve deri ürünleri",
        "13":"16.19 İmalat ve Üretim // Makine ve teçhizat",
        "11":"16.20 İmalat ve Üretim // Tıbbi Cihazlar",
        "22":"16.21 İmalat ve Üretim // Metalik olmayan mineraller",
        "2":"16.22 İmalat ve Üretim // Kişisel ve evde bakım ürünleri",
        "23":"16.23 İmalat ve Üretim // Selüloz, kağıt ve kağıt türevleri",
        "4":"16.24 İmalat ve Üretim // Kauçuk ve plastik ürünler",
        "25":"16.25 İmalat ve Üretim // Güvenlik",
        "26":"16.26 İmalat ve Üretim // Tekstil ve tekstil ürünleri",
        "30":"16.27 İmalat ve Üretim // Taşıma ekipmanları",
        "29":"16.28 İmalat ve Üretim // Su temini ve arıtma",
        "12":"16.29 İmalat ve Üretim // Ahşap ve ahşap türevleri",
        "32":"16.30 İmalat ve İmalat // Diğer",
        "27":"(ESKİ) İmalat ve Üretim // Hızlı hareket eden tüketim malları",
        "9":"(ESKİ) İmalat ve Üretim // Sağlık",
     }
  },
  "9":{
     "NOMBRE":"17.0 Medya",
     "SUBSECTORES":{
        "1":"17.1 Medya // Yayıncılar ve yazıcılar",
        "4":"17.2 Medya // Televizyon / Film / Video",
        "2":"17.3 Medya // Radyo",
        "3":"17.4 Medya // İnternet Hizmetleri",
        "5":"17.5 Medya // Diğer",
     }
  },
  "10":{
     "NOMBRE":"18.0 Madencilik ve taş ocakları",
     "SUBSECTORES":{
        "1":"18.1 Maden ve Taş Ocakları // Diğer / Uygulanmaz"
     }
  },
  "11":{
     "NOMBRE":"(ESKİ) Kar amacı gütmeyen ve hayır kurumları",
     "SUBSECTORES":{
        "1":"-"
     }
  },
  "12":{
     "NOMBRE":"21.0 Perakende Ticaret",
     "SUBSECTORES":{
        "4":"21.1 Perakende Ticaret // Giyim / Tekstil / Ayakkabı",
        "2":"21.2 Perakende Ticaret // Bilgisayar / Elektronik",
        "1":"21.3 Perakende Ticaret // Gıda / Depo",
        "5":"21.4 Perakende Ticaret // Elektronik Ticaret",
        "3":"21.5 Perakende Ticaret // Özel Ürünler",
        "6":"21.6 Perakende Ticaret // Diğer",
     }
  },
  "13":{
     "NOMBRE":"11.0 Finansal Hizmetler ve Sigorta",
     "SUBSECTORES":{
        "1":"11.1 Finansal Hizmetler ve Sigorta // Yatırımlar",
        "9":"11.2 Finansal Hizmetler ve Sigorta // Muhasebe",
        "8":"11.3 Finans ve Sigorta Hizmetleri // Bankacılık / Kredi Hizmetleri",
        "5":"11.4 Finansal Hizmetler ve Sigorta // Sağlık Sigortası",
        "7":"11.5 Finansal Hizmetler ve Sigorta // Genel Sigorta",
        "6":"11.6 Finansal Hizmetler ve Sigorta // Hayat Sigortası",
        "3":"11.7 Finansal Hizmetler ve Sigorta // Otomobil Sigortası",
        "4":"11.8 Finansal Hizmetler ve Sigorta // Ev Sigortası",
        "2":"11.9 Finansal Hizmetler ve Sigorta // Reasürans",
        "10":"11.10 Finansal Hizmetler ve Sigorta // Diğer",
     }
  },
  "14":{
    "NOMBRE":"14.0 Endüstriyel Hizmetler",
    "SUBSECTORES":{
      "3":"14.1 Endüstriyel Hizmetler // Araç Tamiri ve Bakımı",
      "2":"14.2 Endüstriyel Hizmetler // Endüstriyel Tasarım",
      "1":"14.3 Endüstriyel Hizmetler // Atık / Çöp / Geri Dönüşüm Yönetimi",
      "4":"14.4 Endüstriyel Hizmetler // Diğer",
    }
  },
  "15":{
     "NOMBRE":"19.0 Profesyonel Hizmetler",
     "SUBSECTORES":{
        "14":"19.1 Profesyonel Hizmetler // Reklamcılık ve Pazarlama",
        "2":"19.2 Profesyonel Hizmetler // Mimarlık / Tasarım",
        "5":"19.3 Profesyonel Hizmetler // Danışmanlık - Yönetim",
        "7":"19.4 Profesyonel Hizmetler // Mühendislik Danışmanlığı",
        "4":"19.5 Profesyonel Hizmetler // Çevre Danışmanlığı",
        "8":"19.6 Profesyonel Hizmetler // İmalat Danışmanlığı",
        "3":"19.7 Profesyonel Hizmetler // Risk Değerlendirmesi / Aktüeryal Danışmanlık",
        "11":"19.8 Profesyonel Hizmetler // Hukuki Danışmanlık",
        "16":"19.9 Profesyonel Hizmetler // Güvenlik",
        "15":"19.10 Profesyonel Hizmetler // Personel Alımı",
        "6":"19.11 Profesyonel Hizmetler // Telefonla Destek / Satış Merkezleri",
        "1":"19.12 Profesyonel Hizmetler // Seyahat Yönetimi",
        "19":"19.13 Profesyonel Hizmetler // Diğer",
        "12":"(ESKİ) Profesyonel hizmetler // İş süreci dış kaynak kullanımı",
        "13":"(ESKİ) Profesyonel hizmetler // İş süreçleri dış kaynak kullanımı / Çağrı merkezleri",
        "9":"(ESKİ) Profesyonel Hizmetler // Muhasebe, Defter Tutma ve Denetim",
        "17":"(ESKİ) Profesyonel hizmetler // Reklamcılık ve pazarlama / Reklamcılık",
        "18":"(ESKİ) Profesyonel Hizmetler // Reklamcılık ve Pazarlama / Doğrudan Pazarlama",
        "10":"(ESKİ) Profesyonel hizmetler // Eğitim ve öğretim"
     }
  },
  "16":{
     "NOMBRE":"22.0 Sosyal Hizmetler ve Devlet Kurumları",
     "SUBSECTORES":{
        "3":"22.1 Sosyal Hizmetler ve Devlet Kurumları // Ticari Hizmetler",
        "1":"22.2 Sosyal Hizmetler ve Devlet Kurumları // Kültür ve Sanat",
        "2":"22.3 Sosyal Hizmetler ve Devlet Kurumları // Eğitim",
        "6":"22.4 Sosyal Hizmetler ve Devlet Kurumları… Genel kamu yönetimi faaliyetleri",
        "5":"22.5 Sosyal Hizmetler ve Devlet Kurumları // Konut",
        "4":"22.6 Sosyal Hizmetler ve Devlet Kurumları // İnsan Sağlığı ve Sosyal Hizmet",
        "7":"22.7 Sosyal Hizmetler ve Devlet Kurumları // Yatılı Bakım",
        "8":"22.8 Sosyal Hizmetler ve Devlet Kurumları // Diğer",
     }
  },
  "17":{
     "NOMBRE":"15.0 Bilgi Teknolojileri",
     "SUBSECTORES":{
        "3":"15.1 Bilgi Teknolojisi // Donanım",
        "4":"15.2 Bilgi Teknolojisi // İnternet Servis Sağlayıcı",
        "5":"15.3 Bilgi Teknolojisi // Yazılım",
        "6":"15.4 Bilgi Teknolojileri // İnternet Hizmetleri",
        "1":"15.5 Bilgi Teknolojisi // BT Danışmanlığı",
        "2":"15.6 Bilgi Teknolojisi // Veri Depolama / Yönetim",
        "7":"15.7 Bilgi Teknolojisi // Diğer",
     }
  },
  "18":{
     "NOMBRE":"24.0 Ulaşım",
     "SUBSECTORES":{
        "2":"24.1 Ulaştırma // Havayolu / Ticari Havacılık",
        "1":"24.2 Taşıma // Koli taşımacılığı",
        "3":"24.3 Taşıma // Kara ve deniz yolcu taşımacılığı",
        "4":"24.4 Taşıma // Taşıma ve Depolama",
        "5":"24.5 Taşıma // Diğer",
     }
  },
  "19":{
     "NOMBRE":"23.0 Telekomünikasyon",
     "SUBSECTORES":{
        "1":"23.1 Telekomünikasyon // Diğer / Geçerli değil"
     }
  },
  "20":{
     "NOMBRE":"8.0 Elektronik",
     "SUBSECTORES":{
        "1":"8.1 Elektronik // Diğer / Geçerli değil"
     }
  },
  "21":{
     "NOMBRE":"9.0 Mühendislik",
     "SUBSECTORES":{
        "1":"9.1 Mühendislik // Diğer / Geçerli değil"
     }
  },
  "22":{
     "NOMBRE":"10.0 Eğlence",
     "SUBSECTORES":{
        "3":"10.1 Eğlence // Gösteri sanatları ve seyirci sporları",
        "2":"10.2 Eğlence // Müzeler",
        "1":"10.3 Eğlence // Eğlence ve şans oyunları",
        "4":"10.4 Eğlence // Diğer",
     }
  },
  "23":{
     "NOMBRE":"20.0 Gayrimenkul",
     "SUBSECTORES":{
        "1":"20.1 Emlak // Konut",
        "2":"20.2 Gayrimenkul // Mülk yönetimi",
        "3":"20.3 Emlak // Diğer",
     }
  },
  "24":{
     "NOMBRE":"25.0 Diğer",
     "SUBSECTORES":{
        "1":"25.1 Diğer / Geçerli değil"
     }
  },
  "25": {
    "NOMBRE":"3.0 Yaşlılara Yönelik Hizmetler",
    "SUBSECTORES": {
      "1":"3.1 Yaşlılar için Hizmetler // Yaşlılar için barınma ve bakım",
      "2":"3.2 Yaşlılara Yönelik Hizmetler // Evde Bakım",
      "3":"3.3 Yaşlılara Yönelik Hizmetler // Diğer",
    }
  }
}

export const ranking = {
  '1': {
    'NOMBRE': 'eğer',
    'TIPO': {
      '1': '50 den az',
      '2': '50 - 500 Çok Uluslu',
      '3': '50 - 500 Çokuluslu',
      '4': 'Büyük (500 ila 4999)',
      '5': '5000 veya daha fazla'
      // '6': 'Kamu sektörü',
      // '7': 'Sıralamaya katılmıyor'
    }
  },
  '2': {
    'NOMBRE': 'değil',
    'TIPO': {
      '1': '50 den az',
      '2': '50 - 500 Çok Uluslu',
      '3': '50 - 500 Çokuluslu',
      '4': 'Büyük (500 ila 4999)',
      '5': '5000 veya daha fazla'
    }
  },
  'Nacional': 'Ulusal',
  'Multinacional': 'çok uluslu'
}

  export const productos = {
    '1': 'Onayla',
    '2': 'Ölçüm',
    '3': 'NOM-035',
    '4': 'Nabız Kontrolü',
    '5': 'Belgesel NOM-035',
    '6': 'Odak alanı',
    '7': 'Dosya yöneticisi',
    '8': 'Kültür Denetimi',
    '9': 'Kültür Denetimi 5.0',
    '10': 'Kültür Denetimi Eğitimi',
    '11': 'Ölçüm artırıldı',
    '12': 'Ölçüm + MST',
    '13': 'Alanlara göre ölçüm',
    '14': 'Liderlerin ölçümü',
    '15': 'Boyutlara göre ölçüm',
    '16': 'Onaylanacak ölçüm',
    '17': 'Sonuçlar',
    '19': 'NOM-035 Daha iyi',
    '20': 'V2.0 sertifikası',
    '21': 'Global sonuçlar',
    '22': '4ALL tek sonuçları uygular',
    '23': 'Sonuçları tamamla',
    '24': 'GÜMÜŞ paketi',
    '25': 'GOLD paketi',
    '26': 'PLATINUM paketi',
    '37':'Kültür Denetimi SP',
    '40': 'V3.0 sertifikası',
    '41': 'v3.0 Ölçüm',
    '42': 'v3.0 Nabız Kontrolü',
    '43 ':'Odak Alanı v3.0',
    'CULTUREGOEXPRESS':'Cultural Go Express',
    '53':'Lider GO',
    '54':'Action GO',
    '56': 'AMCO',
    '57': 'İnsana Yakışır İş',
    '58':'İlk İş',
    'ENCUESTA':'Ek sertifikalar',
    '60':'Sertifikalandır (ithalat emprising)',
    '61':'Kültür Özeti',
    '62':'Kültür Denetimi',
    '63': 'NOM-035 v3.0',
    '64':'SP 2022',
    '65':'Kültür Denetimi GoFlow 2 2022',
    '66':'Kültür Denetim Standardı 1',
    '67':'Kültür Denetimi® CA&C',
    '69': 'Gümüş sertifikalandır',
    '70':'GoFlow sonuçları',
    '71':'Kültür denetimi (onaylama) 2022',
   '72':'Kültürel denetim (onay, rkg.) 2022',
   '73':'Kültürel denetim (onay, rkg. y adic.) 2022',
   '68':'Swift',
   '76':'Kültürel denetim (onay,,rkg. y adic.) 2024',
   '77':'Kültür Özeti (onay) 2024',
   '78':'Kültür Denetimi (onay ve sıralama) 2024',
  }

  export const productosTurquia = {

    '1': 'Onayla',
    '2': 'Ölçüm',
    '3': 'NOM-035',
    '4': 'Nabız Kontrolü',
    '5': 'Belgesel NOM-035',
    '6': 'Odak alanı',
    '7': 'Dosya yöneticisi',
    '8': 'Culture Audit ',
    '9': 'Kültür Özeti ve Kültür Denetimi 5.0',
    '10': 'Kültür Denetimi Eğitimi',
    '11': 'Ölçüm artırıldı',
    '12': 'Ölçüm + MST',
    '13': 'Alanlara göre ölçüm',
    '14': 'Liderlerin ölçümü',
    '15': 'Boyutlara göre ölçüm',
    '16': 'Onaylanacak ölçüm',
    '17': 'Sonuçlar',
    '19': 'NOM-035 Daha iyi',
    '20': 'V2.0 sertifikası',
    '21': 'Global sonuçlar',
    '22': '4ALL tek sonuçları uygular',
    '23': 'Sonuçları tamamla',
    '24': 'GÜMÜŞ paketi',
    '25': 'GOLD paketi',
    '26': 'PLATINUM paketi',
    '28': 'Kültür Özeti 5.0',
    '29': 'Kültür Denetimi 5.0',
    '34': 'Resultados 5.0 Versão 3.1',
    '35': 'Resultados 5.0 Versão 3.2',
    '36': 'Resultados 5.0 Versão 3.3',
    '38': 'Eylem Planı',
    '40': 'V3.0 sertifikası',
    '41': 'v3.0 Ölçüm',
    '42': 'v3.0 Nabız Kontrolü',
    '43': 'Odak Alanı v3.0',
    '60':'Sertifikalandır (ithalat emprising)',
    '54':'Action GO',
    '74':'Özel Liste',

  }

export const categorias = {
  'Certify': 'Ürünleri sertifikalandırın',
  'Measure': 'Ölçüm ürünleri',
  'Norm 35': 'NOM-035 ürünler',
  'Pulse Check': 'Nabız Kontrolü ürünleri',
  'Focus Area': 'Odak alanı ürünleri',
  'Drive': 'Dosya yöneticisi',
  'Culture Audit': 'Culture Audit ürünleri',
  'Resultados': 'Sonuçların ürünleri',
  'Resultados 4 ALL': '4ALL ürünleri',
  'Resultados 5.0': 'Sonuçlar 5.0 ürünleri',
  'Culture Audit Action Plan':'Hareket planı',
  'Leader GO':'Lider GO',
  'Action GO':'Action GO',
  'Certify Amco':'Ek sertifikalar',
  'PRODUCTOS_ICCA':'ICCA products',
  'Resultados V2 HK':'Sertifikalandır (ithalat emprising)',
  'Swift':'Swift',

}

export const niveles = {
  '1': 'şirket',
  '2': 'Yönetici',
  '3': 'ITBM',
  '4': 'Sonuçlar',
  '5': 'Bölümlenmiş sonuçlar',
  '8': 'ürün Culture Audit',
  '9':'Sonuçlar 5.0',
  '10':'Şirket İK',
  '11': 'Izzi',
  '12': 'ActionGo',
  '13': 'Bölümlere Ayrılmış Sonuçlar ve ActionGo',
  '14': 'ActionGo Lideri',
  '15': 'Kullanıcı ActionGo Lideri',
  '17': 'Swift Wholesaler',
  '18': 'Web şirket profili',
  '19': 'Sonuçlar 2.0',
}

export const regiones = {
  '1': 'Karayip',
  '2': 'Orta Amerika',
  '3': 'Orta Amerika ve Karayipler',
  '4': 'Bölge Bajio',
  '5': 'Merkezi Bölge',
  '6': 'Batı Merkez Bölgesi',
  '7': 'Güney Merkez Bölgesi',
  '8': 'Kuzeydoğu Bölgesi',
  '9': 'Kuzeybatı Bölgesi',
  '10': 'Güneydoğu Bölgesi',
  '11': 'Büyük Çin',
  '12': 'Tayvan',
  '13': 'Anakara Çin',
  '14': 'Büyük Çin',
  '15': 'Türkiye',
}

export const plantillas = {
  '5d826095d06d596a84de6315': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
  },

  '5dcb61e940fb582bc44adf49': {
    'NOMBRE':'TR_ESTANDAR'
  },

  '5dcc946633e1ff000870107e': {
    'NOMBRE':'04_ENGLISH_JAPAN'
  },

  '5dcdd9fd33e1ff1aacf6f04f': {
    'NOMBRE':'01_NORM035_ES_EN_-50'
  },

  '5ddc3fa4f323d727d09870ad': {
    'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
  },

  '5de58de640fb582e0c18d730': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
  },

  '5de69aa4a943da3efc4d0fa6': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_PULSECHECK'
  },

  '5de9498fa943da3efc4d0fa8': {
    'NOMBRE':'05_ING_ESTANDAR'
  },

  '5df820df65e4986b14d1f71c': {
    'NOMBRE':'01_NORM035_ES_EN_+50'
  },

  '5dfc26cec8800d5188a18875': {
    'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
  },

  '5e166105d06d595eb04dca00': {
    'NOMBRE':'Focus_Estandar'
  },

  '5e1754a5f323d72aac6d8726': {
    'NOMBRE':'TR TI + EVP + GPTW LEADER'
  },

  '5e17930b65e4983a3016a4ed': {
    'NOMBRE':'TR TI + EVP'
  },

  '5e2100c6f323d721045812c5': {
    'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
  },

  '5e21042ff323d721045812c6': {
    'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
  },

  '5e210575f323d721045812c7': {
    'NOMBRE':'04_ESP_GOBIERNO'
  },

  '5e2b6dbdc8800d52f45fc248': {
    'NOMBRE':'TEMPLATE 10 PREGUNTAS ESP'
  },

  '5e2f72c8c8800d3398c463a4': {
    'NOMBRE':'CAYC_GOBIERNO'
  },

  '5e3c59b5b473cb6d3e40f902': {
    'NOMBRE':'ING_RUMANO_ESTANDAR'
  },

  '5e697232b473cb6d3e84d87d': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
  },

  '5e6972f3b473cb6d3e84e1e0': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR1'
  },

  '5e697302b473cb6d3e84e2a3': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR2'
  },

  '5e697311b473cb6d3e84e364': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR3'
  },

  '5e697329b473cb6d3e84e490': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR4'
  },

  '5e69734fb473cb6d3e84e656': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR5'
  },

  '5e697367b473cb6d3e84e791': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR6'
  },

  '5e738efbb473cb6d3e8c3915': {
    'NOMBRE':'ESP_CAYC_Diversidad'
  },

  '5e86487eb473cb6d3e09cc42': {
    'NOMBRE':'01_NORM035_ES_EN_-50'
  },

  '5e864896b473cb6d3e09cde1': {
    'NOMBRE':'01_NORM035_ES_EN_+50'
  },

  //PLANTILLAS DE CERTIFICAR 2.0
  '5e960018b473cb6d3ec5f935': {
    'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
  },

  '5e96007cb473cb6d3ec60098': {
    'NOMBRE':'TR_ESTANDAR'
  },

  '5e9600a6b473cb6d3ec603c7': {
    'NOMBRE':'04_ENGLISH_JAPAN'
  },

  '5e9600f0b473cb6d3ec6095a': {
    'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
  },

  '5e960116b473cb6d3ec60c2f': {
    'NOMBRE':'05_ING_ESTANDAR'
  },

  '5e96039fb473cb6d3ec64310': {
    'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
  },

  '5e9603d7b473cb6d3ec6485e': {
    'NOMBRE':'TR TI + EVP + GPTW LEADER'
  },

  '5e9604f7b473cb6d3ec66540': {
    'NOMBRE':'TR TI + EVP'
  },

  '5e960525b473cb6d3ec66a3f': {
    'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
  },

  '5e960549b473cb6d3ec66e30': {
    'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
  },

  '5e96056ab473cb6d3ec671f1': {
    'NOMBRE':'04_ESP_GOBIERNO'
  },

  '5e9605b5b473cb6d3ec67a55': {
    'NOMBRE':'CAYC_GOBIERNO'
  },

  '5e9605e0b473cb6d3ec67f3c': {
    'NOMBRE':'ING_RUMANO_ESTANDAR'
  },

  '5e96060fb473cb6d3ec684d8': {
    'NOMBRE':'ESP_CAYC_Diversidad'
  },
  '5f84a2fab473cb6d3e017c0d': {
    'NOMBRE':'ESP_ESTANDAR_IDIOMAS'
  },
  '5f733fcab473cb6d3e19d56c': {
    'NOMBRE':'04_ESP_Gobierno_MX'
  },
  // pendiente TK
  '5e14fc2cf323d72aac6d8722': {
    'NOMBRE':' '
  },
  // pendiente TK
  '5e14fcc4f323d72aac6d8723': {
    'NOMBRE':' '
  },
  // pendiente MX
  '5d71b21db11f333a30de813e': {
    'NOMBRE':' '
  },
  '5fcebf59c1057065a70fe712':{
    'NOMBRE':'TR_ESTANDAR_+COVID v2'
  },
  '6046a10e7308ab51607f95b5':{
    'NOMBRE':''
  }
}

export const answer = {
  '1': 'Kültürel Go Anketi',
  '2': 'Kiosko',
  '3': 'Cevap yok / Yabancı lider',
  '4': 'kâğıt',
  '5': 'Geçerli değil',
}
